import React, { useEffect, useState } from "react";
import "./orderMIRT.style.scss";
import { Button, Card, Dropdown, Input, Radio, Menu, Typography } from "antd";
import { get, post, responseValidator, SITEURL } from "../../../../../api";
import Loading from "../../../../../loading/loading.index";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import { toast } from "react-toastify";
import { ToIranCurrency } from "../../../../../util/string";

export default function OrderS1MIRT() {
    const [payment, setPayment] = useState(null);
    const [allPayment, setALlPayment] = useState([]);
    const [allCards, setAllCards] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [allNetworks, setAllNetworks] = useState([]);
    const [networkSelected, setNetworkSelected] = useState();
    const [depositMethod, setDepositMethod] = useState({
        title: "شبا",
        payload: 1
    });
    const [loading, setLoading] = useState(true);
    const [orderDetail, setOrderDetail] = useState(null);
    const [isMemo, setIsMemo] = useState(false);
    const { Text } = Typography;
    const [wallet, setWallet] = useState(null);
    const [memo, setMemo] = useState(null);
    const [walletBool, setWalletBool] = useState(undefined);
    const [memoBool, setMemoBool] = useState(undefined);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [isAllDisable, setIsAllDisable] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [timeRemaining, setTimeRemaining] = useState(30);
    const [txID, setTxID] = useState(undefined);
    const [address, setAddress] = useState(undefined);
    const [qrCode, setQrCode] = useState(undefined);
    const [voher, setVocher] = useState();
    const [activatior, setActivator] = useState();
    const [timeRemaining2, setTimeRemaining2] = useState(300);

    function s_to_mmss(time = 0) {
        const second = time % 60;
        const min = Math.floor(time / 60);
        return (
            (min < 10 ? "0" + min : min) +
            ":" +
            (second < 10 ? "0" + second : second)
        );
    }

    function counter(value) {
        setTimeRemaining(value);
        if (value > 0) {
            setTimeRemaining(value);
            setTimeout(() => {
                counter(value - 1);
            }, 1000);
        } else {
            setTimeRemaining(30);
        }
    }

    function counter2(value) {
        setTimeRemaining2(value);
        if (value > 0) {
            setTimeRemaining2(value);
            setTimeout(() => {
                counter2(value - 1);
            }, 1000);
        } else {
            setTimeRemaining2(300);
        }
    }

    useEffect(() => {
        if (isAllDisable) counter(30);
        else counter2(300);
    }, [isAllDisable]);

    function getBanks() {
        return new Promise(resolve => {
            get("/BankAccount/Mine").then(res => {
                setPageLoading(false);
                resolve(true);
                if (responseValidator(res.status)) {
                    setSelectedCard(res.data.data[0]);
                    setAllCards(res.data.data);
                }
            });
        });
    }

    function getOrder() {
        setPageLoading(true);
        return new Promise(resolve => {
            get(`/Order/` + localStorage.getItem("order") + `/Details`).then(
                res => {
                    if (allCards.length !== 0) setPageLoading(false);
                    if (responseValidator(res.status)) {
                        setOrderDetail(res.data.data);
                        resolve(res.data.data.depositTransaction.market);
                    } else {
                        window.location.replace("/userpanel/order/");
                        toast.error(res.data.message);
                    }
                }
            );
        });
    }

    async function getDetails() {
        const order = await getOrder();
        const banks = await getBanks();
        // const networks = await getNetworks(order.symbol);
        console.log(order);
        setLoading(false);
    }

    useEffect(() => {
        getDetails();
    }, []);

    useEffect(() => {
        if (networkSelected) {
            if (memo === "") setMemoBool(undefined);
            else {
                console.log(networkSelected.memoRegex);
                const regex = new RegExp(networkSelected.memoRegex);
                console.log(regex);
                console.log(regex.test(memo));
                setMemoBool(regex.test(memo));
            }
        }
    }, [memo]);

    function submitHandler() {
        if (!isAllDisable) {
            setSubmitLoading(true);
            let body = {
                trackingCode: localStorage.getItem("order"),
                voucherCode: voher,
                voucherActivate: activatior,
                destinationBankAccount: selectedCard.id,
                irtWithdrawPayType: depositMethod.payload,
            };

            post("/Order/Deposit/Money", body).then(res => {
                setSubmitLoading(false);
                if (responseValidator(res.status)) {
                    const body2 = {

                        trackingCode: body.trackingCode
                    };
                    window.location.replace(
                        `/userpanel/order/verify/${orderDetail.trackingCode}?amount=4000000&refnum=rWz2B7qO&state=SUCCESSFUL&payment`
                    );
                } else toast.error(res.data.message);
            });
        }

    }

    if (pageLoading) return <Loading />;
    else
        return (
            <div className="order-first-step-irt-c-page">
                <h3>{isAllDisable ? "فاکتور نهایی" : "پیش فاکتور"}</h3>
                <p style={{ margin: "6px" }}>
            
                </p>
                <p style={{ margin: "6px" }}>

                </p>

                <div className="order-first-step-irt-c-page-content">
                    {loading && <Loading />}
                    <Card title="ارز مبدا">
                        <div className="item">
                            <p>نام :‌ </p>
                            <h5>
                                {
                                    orderDetail.depositTransaction.market
                                        .description
                                }
                            </h5>
                            <img
                                alt="crypto"
                                style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "100%",
                                    marginRight: "10px"
                                }}
                                src={
                                    SITEURL +
                                    orderDetail.depositTransaction.market.icon
                                }
                            />
                        </div>
                        <div className="item">
                            <p>مقدار : </p>
                            <h5>
                                {orderDetail.depositTransaction.amount} واحد
                            </h5>
                        </div>
                        <div className="item">
                            <p>کارمزد تبدیل: </p>
                            <h5>
                                {orderDetail.depositTransaction.rateCommssion} واحد
                            </h5>
                        </div>
                        <div className="my-inputs item">
                            <p style={{ marginLeft: "12px", minWidth: "90px" }}>
                            </p>
                            <Input
                                style={{ maxWidth: "400px" }}
                                disabled={isAllDisable}
                                value={voher}
                                onChange={e => setVocher(e.target.value)}
                                placeholder="ووچر"
                            />
                        </div>
                        <div className="my-inputs item">
                            <p style={{ marginLeft: "12px", minWidth: "90px" }}>
                                کد فعال ساز :{" "}
                            </p>
                            <Input
                                style={{ maxWidth: "400px" }}
                                disabled={isAllDisable}
                                value={activatior}
                                onChange={e => setActivator(e.target.value)}
                                placeholder="فعال ساز"
                            />
                        </div>
                    </Card>
                    <Card title="ارز مقصد">
                        <div className="item">
                            <p>نام : </p>
                            <h5>
                                {
                                    orderDetail.withdrawTransaction.market
                                        .description
                                }
                            </h5>
                            <img
                                alt="crypto"
                                style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "100%",
                                    marginRight: "10px"
                                }}
                                src={
                                    SITEURL +
                                    orderDetail.withdrawTransaction.market.icon
                                }
                            />
                        </div>
                        <div className="item">
                            <p>مقدار دریافتی: </p>
                            <h5>
                                {ToIranCurrency(
                                    orderDetail.withdrawTransaction.amount
                                )}{" "}
                                واحد
                            </h5>
                        </div>
                        <div className="card">
                            <p>کارت خود را انتخاب کنید : </p>
                            {allCards.length !== 0 ? (
                                <Dropdown
                                    disabled={isAllDisable}
                                    overlay={
                                        <Menu>
                                            {allCards.map(item => (
                                                <Menu.Item
                                                    onClick={() =>
                                                        setSelectedCard(item)
                                                    }
                                                    key={item.id}
                                                >
                                                    <div className="one-card-drop-down-selected ">
                                                        <img
                                                            src={
                                                                SITEURL +
                                                                item.icon
                                                            }
                                                            alt="Bank"
                                                        />
                                                        <h4>{item.bankName}</h4>
                                                        <p>{item.cardNumber}</p>
                                                    </div>
                                                </Menu.Item>
                                            ))}
                                        </Menu>
                                    }
                                    trigger={["click"]}
                                >
                                    <div className="one-card-drop-down-selected">
                                        <img
                                            src={SITEURL + selectedCard.icon}
                                            alt="Bank"
                                        />
                                        <h4>{selectedCard.bankName}</h4>
                                        <p>{selectedCard.cardNumber}</p>
                                        <DownOutlined />
                                    </div>
                                </Dropdown>
                            ) : (
                                <p>یافت نشد!</p>
                            )}
                        </div>

                    </Card>
                </div>

                <Button
                    style={{ marginTop: "12px" }}
                    disabled={(!voher || !activatior) && !isAllDisable}
                    onClick={submitHandler}
                    loading={submitLoading}
                    type={"primary"}
                >
                    {isAllDisable ? "انتقال به درگاه پرداخت" : "ادامه"}
                </Button>
                <Button
                    style={{ marginTop: "12px" }}
                    onClick={() => (window.location.href = "/userpanel/order")}
                    type={"default"}
                >
                    لغو سفارش
                </Button>
                {isAllDisable ? (
                    <Text type="warning counter">
                        {" "}
                        زمان باقی مانده : {s_to_mmss(timeRemaining)} دقیقه
                    </Text>
                ) : (
                    <Text type="warning counter">
                        {" "}
                        زمان باقی مانده : {s_to_mmss(timeRemaining2)} دقیقه
                    </Text>
                )}
            </div>
        );
}
